import React, { useState } from "react";

export default function DeleteProjectPage({
  projects,
  deleteProject,
  isAdminOfProject,
  isSuperuser,
  onBack,
  onDeleted,
}) {
  const [status, setStatus] = useState("confirm");
  const [errorMsg, setErrorMsg] = useState("");

  const projectId = window.localStorage.getItem("boq.activeProjectId");
  const project   = projectId
    ? projects.find((p) => String(p.id) === String(projectId))
    : null;

  const page = (children) => (
    <div style={{
      minHeight: "100vh", background: "var(--page-gradient)",
      padding: "20px 16px", color: "var(--text-primary)",
      fontFamily: "Arial, sans-serif",
    }}>
      <button className="link" onClick={onBack}>← უკან</button>
      <div style={{ marginTop: 24 }}>{children}</div>
    </div>
  );

  if (projectId && projects.length === 0) {
    return page(
      <div style={{ textAlign: "center", color: "var(--text-muted)", fontSize: 13 }}>
        იტვირთება...
      </div>
    );
  }

  if (!projectId || !project) {
    return page(
      <div style={{
        background: "var(--surface-soft)", border: "1px solid rgba(148,163,184,0.15)",
        borderRadius: 12, padding: "24px 20px", textAlign: "center",
      }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>📂</div>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>
          პროექტი არ არის გახსნილი
        </div>
        <div style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 20, lineHeight: 1.5 }}>
          წასაშლელად ჯერ გახსენი პროექტი "პროექტები" განყოფილებიდან.
        </div>
        <button onClick={onBack} style={btnSecondary}>პროექტების სია</button>
      </div>
    );
  }

  const canDelete = isSuperuser || isAdminOfProject(project.id);
  if (!canDelete) {
    return page(
      <div style={{
        background: "rgba(239,68,68,0.06)", border: "1px solid rgba(239,68,68,0.3)",
        borderRadius: 12, padding: "24px 20px", textAlign: "center",
      }}>
        <div style={{ fontSize: 36, marginBottom: 12 }}>🔒</div>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>
          წვდომა აკრძალულია
        </div>
        <div style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 20, lineHeight: 1.5 }}>
          პროექტის წაშლის უფლება მხოლოდ პროექტის ადმინისტრატორს აქვს.
        </div>
        <button onClick={onBack} style={btnSecondary}>უკან</button>
      </div>
    );
  }

  const handleDelete = async () => {
    setStatus("deleting");
    setErrorMsg("");
    try {
      await deleteProject(project.id);
      onDeleted();
    } catch (err) {
      setErrorMsg(err?.message || "შეცდომა წაშლისას");
      setStatus("error");
    }
  };

  return page(
    <div style={{
      background: "rgba(239,68,68,0.05)", border: "1px solid rgba(239,68,68,0.25)",
      borderRadius: 12, padding: "24px 20px",
    }}>
      <div style={{ textAlign: "center", marginBottom: 20 }}>
        <div style={{ fontSize: 42, marginBottom: 12 }}>⚠️</div>
        <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 10 }}>
          პროექტის წაშლა
        </div>
        <div style={{ fontSize: 13, color: "var(--text-muted)", lineHeight: 1.6, marginBottom: 6 }}>
          დარწმუნებული ხარ, რომ გინდა წაშალო პროექტი
        </div>
        <div style={{
          fontSize: 15, fontWeight: 700, color: "var(--text-primary)",
          background: "rgba(239,68,68,0.08)", borderRadius: 8,
          padding: "8px 16px", display: "inline-block", margin: "4px 0 10px",
        }}>
          {project.name}
        </div>
        <div style={{ fontSize: 12, color: "#fca5a5", lineHeight: 1.5 }}>
          ეს მოქმედება შეუქცევადია — ყველა მონაცემი სამუდამოდ წაიშლება.
        </div>
      </div>

      {(status === "error") && (
        <div style={{
          background: "rgba(239,68,68,0.1)", border: "1px solid rgba(239,68,68,0.35)",
          borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#fca5a5",
          marginBottom: 16, textAlign: "center",
        }}>
          {errorMsg}
        </div>
      )}

      <div style={{ display: "flex", gap: 10 }}>
        <button
          onClick={onBack}
          disabled={status === "deleting"}
          style={btnSecondary}
        >
          გაუქმება
        </button>
        <button
          onClick={handleDelete}
          disabled={status === "deleting"}
          style={{
            flex: 1, padding: "10px 0", borderRadius: 8,
            border: "none", background: "#dc2626", color: "#fff",
            fontWeight: 700, fontSize: 13, cursor: "pointer",
            opacity: status === "deleting" ? 0.6 : 1,
          }}
        >
          {status === "deleting" ? "იშლება..." : "დიახ, წავშალო"}
        </button>
      </div>
    </div>
  );
}

const btnSecondary = {
  flex: 1, padding: "10px 0", borderRadius: 8,
  border: "1px solid rgba(148,163,184,0.25)",
  background: "var(--surface-soft)", color: "var(--text-primary)",
  cursor: "pointer", fontSize: 13, fontWeight: 500,
};
